import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderUpdateSlice = createApi({
    reducerPath: "orderUpdate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        orderUpdate: builder.mutation({
            query: ({ id, data }) => ({
                url: "/order-management/api/v1/order/update?id=" + id,
                method: "PATCH",
                body: data,
            }),
        }),
    }),
});

export const { useOrderUpdateMutation } = orderUpdateSlice;
